module.exports = __webpack_public_path__ + "media/images/items-5f077df730ad662871ff55bca9e5443a.png";